module.exports = __webpack_public_path__ + "img/3.fc5ca186.png";